<template>
    <client-page>
        <template v-if="program">
            <v-container class="container--large">
                <auction-halls-program :program="program" />
            </v-container>
            <v-container>
                <div class="tab-wrap">
                    <auction-halls-groups :value="group" :program="program" />
                </div>
                <div>
                    <auction-halls-search v-bind="{ totalCount }" />
                    <auction-work-list :works="works" class="gallery-card-row" />
                </div>

                <div class="v-pagination-wrap">
                    <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-8 mb-16" @input="(page) => $router.push({ query: { ...this.$route.query, page } })" />
                </div>
            </v-container>
        </template>
        <template v-else-if="!loading">
            <v-container>
                <div class="tit tit--sm text-center pt-80">진행중인 경매가 없습니다.</div>
            </v-container>
        </template>

        <v-fade-transition leave-absolute>
            <v-overlay v-show="loading" color="white" light>
                <v-progress-circular color="primary" indeterminate size="100" width="5" />
            </v-overlay>
        </v-fade-transition>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import AuctionWorkList from "@/components/client/ko/auction/auction-work-list.vue";
import AuctionHallsGroups from "@/components/client/ko/auction/auction-halls-groups.vue";
import AuctionHallsSearch from "@/components/client/ko/auction/auction-halls-search.vue";
import AuctionHallsProgram from "@/components/client/ko/auction/auction-halls-program.vue";

import api from "@/api";
import { AUCTION_PROGRAM_HALLS } from "@/assets/variables";

export default {
    components: {
        ClientPage,
        AuctionWorkList,
        AuctionHallsGroups,
        AuctionHallsSearch,
        AuctionHallsProgram,
    },
    props: {
        hall: { type: String, default: AUCTION_PROGRAM_HALLS.AUCTION_A.value },
        group: { type: String, default: "all" },
    },
    data() {
        return {
            loading: false,

            program: null,
            works: [],

            totalCount: 0,
            limit: 20,
        };
    },
    computed: {
        sort() {
            return this.$route.query.sort || "lot_asc";
        },
        searchKey() {
            return this.$route.query.searchKey || null;
        },
        searchValue() {
            return this.$route.query.searchValue || null;
        },
        page() {
            return +this.$route.query.page || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.totalCount / this.limit) || 1;
        },
        headers() {
            const { skip, limit } = this;
            return { skip, limit };
        },
        params() {
            let { group, sort, searchKey, searchValue } = this;
            if (group == "all") group = null;
            const { _id: _program } = this.program || {};

            return {
                ...(group ? { group } : {}),
                _program,
                sort,
                searchKey,
                searchValue,
            };
        },
    },
    mounted() {
        this.loading = true;
        this.init()
            .then(this.getProgram)
            .then(this.search)
            .finally(this.closeUp);
    },
    watch: {
        hall() {
            this.loading = true;
            this.init()
                .then(this.getProgram)
                .then(this.search)
                .finally(this.closeUp);
        },
        group() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(this.closeUp);
            }
        },
        "$route.query.sort"() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(this.closeUp);
            }
        },
        "$route.query.page"() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(this.closeUp);
            }
        },
        "$route.query.searchKey"() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(this.closeUp);
            }
        },
        "$route.query.searchValue"() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(this.closeUp);
            }
        },
    },
    methods: {
        async init() {
            this.works = [];
            this.totalCount = 0;
        },
        async getProgram() {
            const { hall, group } = this;
            if (!this.$route.path.includes("groups")) this.$router.replace({ path: `/auction-halls/${hall}/groups/${group}` });
            const { program } = await api.v1.auction.halls.get({ hall });

            this.program = program;
        },
        async search({ withRouting = false } = {}) {
            const { page, sort, headers, params } = this;
            if (withRouting) this.$router.push({ query: { page, sort, searchKey, searchValue } });

            var {
                summary: { totalCount },
                works,
            } = await api.v1.auction.works.gets({ headers, params });

            this.works = works;
            this.totalCount = totalCount;
        },
        async closeUp() {
            this.loading = false;
            if (!this.program && !this.loading) alert("진행중인 경매가 없습니다.");
        },
    },
};
</script>
